// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ry13","label":"styles_label__3FXKl"};